import React from "react";
import PropTypes from "prop-types";

const ReviewSchema = ({ reviews = [], averageRating, totalReviews}) => {
    return (
        !!(reviews || []).length && <script type="application/ld+json" dangerouslySetInnerHTML={{
            __html: JSON.stringify(
                {
                    "@context": "https://schema.org",
                    "@type": "Product",
                    "name": "Cars24",
                    "aggregateRating": {
                        "@type": "AggregateRating",
                        "ratingValue": averageRating,
                        "reviewCount": totalReviews
                    },
                    "review": reviews.map((review) => ({
                        "@type": "Review",
                        "author": {
                            "@type": "Person",
                            "name": review.customer_name || "Anonymous"
                        },
                        "reviewRating": {
                            "@type": "Rating",
                            "ratingValue": `${review.review_rating}`,
                            "bestRating": "5"
                        },
                        "datePublished": new Date(review.created_at).toISOString(),
                        "reviewBody": review.review_description || ""
                    }))
                },
            )
        }} />
    );
};

ReviewSchema.propTypes = {
    reviews: PropTypes.array,
    averageRating: PropTypes.number,
    totalReviews: PropTypes.number
};

export default ReviewSchema;

